// extracted by mini-css-extract-plugin
module.exports = {"backButton":"BackButton-module__backButton"};